import { render } from "./PersonalSetting.vue?vue&type=template&id=3896bcc5"
import script from "./PersonalSetting.vue?vue&type=script&lang=js"
export * from "./PersonalSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__